import React, { useState } from "react";
import { Message, Button } from "semantic-ui-react";
import InspectionRequestModal from "../inspection-request-modal/InspectionRequestModal";

interface PublicInspectionMessageProps {
  inspectionId: string | number;
  title: string;
}
export default function PublicInspectionMessage({ inspectionId, title }: PublicInspectionMessageProps) {
  const [open, setOpen] = useState(false);
  return (
    <>
      <InspectionRequestModal inspectionId={inspectionId.toString()} isOpen={open} onClose={() => setOpen(false)} />
      <Message className='tw-flex tw-grow tw-items-center tw-justify-between' warning>
        {title}
        <Button
          primary
          onClick={() => {
            setOpen(true);
          }}
        >
          Request Inspection
        </Button>
      </Message>
    </>
  );
}
